<template>
  <div class="firstDepositDetail">
    <div class="head">
      <img src="../../assets/images/depositDetail/headBg.webp" alt="" class="bg">
      <div class="topBack" @click="back()">
        <img src="../../assets/images/depositDetail/backIcon.png" alt="" class="backIcon">
        <div class="backLabel">{{$t('lang.FirstDepositStreamer.backLabel')}}</div>
      </div>
      <div class="FirstDepositStreamerDescription" v-html="getFirstDepositStreamerDescription($t('lang.FirstDepositStreamer.description'),'First')"></div>
      <div class="timerBox">
        <div class="timer">{{firstDepositStreamerTimer.hour1}}</div>
        <div class="timer">{{firstDepositStreamerTimer.hour2}}</div>
        <div class="timer2">：</div>
        <div class="timer" style="position: relative;left: -6.5vw">{{firstDepositStreamerTimer.minute1}}</div>
        <div class="timer" style="position: relative;left: -6.5vw">{{firstDepositStreamerTimer.minute2}}</div>
      </div>
      <div class="btn" @click="goto('Deposit')">{{$t('lang.FirstDepositStreamer.redeem')}}</div>
    </div>
    <div class="itemBox">
      <div style="margin-top: 10vw" :class="userDepositBonusState.FirstDeposit?'depositBonusItem':'depositBonusItemNONE'" :style="{backgroundImage:'url('+require('../../assets/images/depositDetail/itemBg.png')+')'}">
        <div class="row">
          <div class="labelBox">
            <div class="label">{{ $t('lang.FirstDepositStreamer.firstDeposit') }}</div>
          </div>
          <div class="maximumReward">{{ $t('lang.FirstDepositStreamer.maximumReward') }}₹{{userDepositBonusRate.FirstDepositMaxReward}}</div>
        </div>
        <div class="row2" v-html="getFirstDepositStreamerDescription($t('lang.FirstDepositStreamer.claimNowFirst'), 'First')"></div>
      </div>
      <div :class="userDepositBonusState.TwiceDeposit || userDepositBonusState.FirstDeposit?'depositBonusItem':'depositBonusItemNONE'" :style="{backgroundImage:'url('+require('../../assets/images/depositDetail/itemBg.png')+')'}">
        <div class="row">
          <div class="labelBox">
            <div class="label">{{ $t('lang.FirstDepositStreamer.secondDeposit') }}</div>
          </div>
          <div class="maximumReward">{{ $t('lang.FirstDepositStreamer.maximumReward') }}₹{{userDepositBonusRate.TwiceDepositMaxReward}}</div>
        </div>
        <div class="row2" v-html="getFirstDepositStreamerDescription($t('lang.FirstDepositStreamer.claimNowSecond'), 'Second')"></div>
      </div>
      <div :class="userDepositBonusState.ThirdDeposit || userDepositBonusState.TwiceDeposit || userDepositBonusState.FirstDeposit?'depositBonusItem':'depositBonusItemNONE'" :style="{backgroundImage:'url('+require('../../assets/images/depositDetail/itemBg.png')+')'}">
        <div class="row">
          <div class="labelBox">
            <div class="label">{{ $t('lang.FirstDepositStreamer.thirdDeposit') }}</div>
          </div>
          <div class="maximumReward">{{ $t('lang.FirstDepositStreamer.maximumReward') }}₹{{userDepositBonusRate.ThirdDepositMaxReward}}</div>
        </div>
        <div class="row2" v-html="getFirstDepositStreamerDescription($t('lang.FirstDepositStreamer.claimNowThird'), 'Third')"></div>
      </div>
    </div>
    <div class="ruleBox">
      <div class="title">{{ $t('lang.FirstDepositStreamer.rules') }}</div>
      <div class="content" v-html="ruleHtml">

      </div>
    </div>
  </div>
</template>

<script>
import request from '@/service'
export default {
  name: 'index',
  data () {
    return {
      firstDepositStreamerTimer: {
        hour1: 0,
        hour2: 0,
        minute1: 0,
        minute2: 0,
        second1: 0,
        second2: 0
      },
      ruleHtml: '',
      promotion: '',
      userDepositBonusState: {},
      userDepositBonusRate: {}
    }
  },
  mounted () {
    this.getFirstDepositStreamerTimer()
    this.loadData()
  },
  beforeDestroy () {
    localStorage.removeItem('userDepositBonusState')
    localStorage.removeItem('userDepositBonusRate')
  },
  methods: {
    goto (path) {
      this.$router.push(path)
    },
    back () {
      localStorage.removeItem('userDepositBonusState')
      localStorage.removeItem('userDepositBonusRate')
      this.$router.back()
    },
    loadData: function () {
      if (localStorage.getItem('userDepositBonusState')) {
        this.userDepositBonusState = JSON.parse(localStorage.getItem('userDepositBonusState'))
      }
      if (localStorage.getItem('userDepositBonusRate')) {
        this.userDepositBonusRate = JSON.parse(localStorage.getItem('userDepositBonusRate'))
      }
      this.userInfo = localStorage.getItem('userInfo')
      let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      if (!this.userInfo) {
        cid = null
      }
      const url = 'innovation/home/promotion/get/one'
      let param = 'local=' + (localStorage.getItem('locale') || 'EN') + '&client=app&campaignId=' + cid + '&key=' + 'FirstDeposit'
      let fullUrl = url + '?' + param
      request('get', fullUrl).then(res => {
        let item = res.Result
        this.promotion = {
          ...item,
          startUpPopup: item.SequenceNo,
          name: item.Name,
          category: item.Category.split(','),
          key: item.KeyText,
          path: item.Url,
          type: item.PromotionType,
          introduceImg: item.Cover
        }
        console.log(this.promotion)
        this.ruleHtml = this.promotion.Content
      }).catch(err => {
        console.log(err)
      })
    },
    getFirstDepositStreamerDescription (val, type) {
      if (val && type === 'First') {
        return val.replace('{rate}', this.userDepositBonusRate.FirstDiscountPre || 0)
      } else if (val && type === 'Second') {
        return val.replace('{rate}', this.userDepositBonusRate.TwiceDiscountPre || 0)
      } else if (val && type === 'Third') {
        return val.replace('{rate}', this.userDepositBonusRate.ThirdDiscountPre || 0)
      }
    },
    getFirstDepositStreamerTimer () {
      this.firstDepositStreamerTimer.hour1 = this.$getRemainingTimeToday().hour1
      this.firstDepositStreamerTimer.hour2 = this.$getRemainingTimeToday().hour2
      this.firstDepositStreamerTimer.minute1 = this.$getRemainingTimeToday().minute1
      this.firstDepositStreamerTimer.minute2 = this.$getRemainingTimeToday().minute2
      this.firstDepositStreamerTimer.second1 = this.$getRemainingTimeToday().second1
      this.firstDepositStreamerTimer.second2 = this.$getRemainingTimeToday().second2
      this.firstDepositStreamerTimerInterval = setInterval(() => {
        this.firstDepositStreamerTimer.hour1 = this.$getRemainingTimeToday().hour1
        this.firstDepositStreamerTimer.hour2 = this.$getRemainingTimeToday().hour2
        this.firstDepositStreamerTimer.minute1 = this.$getRemainingTimeToday().minute1
        this.firstDepositStreamerTimer.minute2 = this.$getRemainingTimeToday().minute2
        this.firstDepositStreamerTimer.second1 = this.$getRemainingTimeToday().second1
        this.firstDepositStreamerTimer.second2 = this.$getRemainingTimeToday().second2
      }, 60000)
    }
  }
}
</script>

<style lang="less" scoped>
.firstDepositDetail{
  display: flex;
  flex-direction: column;
  //background-color: #000;
  overflow-x: hidden;
  .head{
    height: 59.166vw;
    width: 110.433vw;
    background-size: 100% 100%;
    position: relative;
    .bg{
      position: absolute;
      width: 121.558vw;
      height: 87.552vw;
      top: -6vw;
    }
    .topBack{
      padding: 0 3vw;
      display: flex;
      align-items: center;
      gap: 4vw;
      height: 15vw;
      position: absolute;
      top: 14vw;
      .backIcon{
        width: 3.688vw;
        height: 5.444vw;
      }
      .backLabel{
        font-family: 'Arial';
        font-style: normal;
        font-weight: 700;
        font-size: 5vw;
        color: #EBD2A1;
        margin-top: 1.2vw;
      }
    }
    .FirstDepositStreamerDescription{
      width: 66.555vw;
      font-family: 'Inter';
      font-style: italic;
      font-weight: 600;
      font-size: 4.305vw;
      line-height: 17px;
      text-transform: capitalize;
      color: #FFFFFF;
      position: absolute;
      left: 3.388vw;
      top: 27.5vw;
    }
    .timerBox{
      display: flex;
      align-items: center;
      position: absolute;
      left: 4.3vw;
      top: 41vw;
      //width: 39.122vw;
      gap: 2vw;
      .timer{
        font-family: 'Inter';
        font-weight: 900;
        font-size: 7.5vw;
        text-transform: capitalize;
        color: #000;
        background-color: #FAF6E4;
        height: 10.619vw;
        width: 7.222vw;
        border-radius: 0.555vw;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .timer2{
        font-family: 'Inter';
        font-weight: 900;
        font-size: 7.5vw;
        text-transform: capitalize;
        color: #FAF6E4;
        letter-spacing: 2.8vw;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        left: 0vw;
        top: -0.5vw;
      }
    }
    .btn{
      width: 84vw;
      height: 10.488vw;
      border-radius: 1.111vw;
      background-color: #F1DAB0;
      color: #000;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 8.3vw;
      top: 55vw;
      font-weight: 700;
    }
  }
  .itemBox{
    display: flex;
    flex-direction: column;
    gap: 4vw;
  }
  .ruleBox{
    height: 102.777vw;
    width: 94.513vw;
    border-radius: 1.666vw;
    padding: 3.958vw;
    background: #222020;
    margin-left: 2.2vw;
    margin-top: 3vw;
    color: #B3B3B3;
    display: flex;
    flex-direction: column;
    .title{
      height: 3.888vw;
      color: #fff;
      font-weight: 700;
      padding-bottom: 10vw;
    }
    .content{
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;
      /deep/span{
        color: #B3B3B3 !important;
        font-size: 3.611vw;
      }
    }
  }
  .depositBonusItemNONE{
    width: 94.5%;
    height: 21.944vw;
    padding: 3.2vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 3vw;
    border-radius: 1.666vw;
    background-image: none !important;
    background-color: #222222;
    margin-left: 2.3vw;
    .row{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20vw;
      .labelBox {
        flex: 1;
        margin-left: 2vw;
        //border: 1px solid red;
        .label {
          background-color: #1C1C1C;
          font-weight: 700;
          width: 27vw;
          height: 7vw;
          color: #3F3F3F;
          border-radius: 1vw;
          font-size: 3.888vw;
        }
      }
      .maximumReward{
        font-size: 3.611vw;
        color: #515151;
      }
    }
    .row2{
      color: #515151;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2vw;
      font-size: 3.611vw;
      font-weight: 700;
     /deep/ span{
        color: #515155 !important;
      }
    }
  }
.depositBonusItem{
  width: 100%;
  height: 21.944vw;
  background-size: 100% 100%;
  padding: 3.2vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3vw;
  .row{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20vw;
    .labelBox{
      flex: 1;
      margin-left: 2vw;
      //border: 1px solid red;
      .label{
        //background-color: #191715;
        //padding: 2vw;
        color: #F1DAB0;
        border-radius: 1vw;
        font-size: 3.3vw;
        font-weight: 700;
        //width: 27vw;
        height: 7vw;
        //border: 1px solid red;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .maximumReward{
      font-size: 3.611vw;
      color: #7D7D7D;
      width: 45%;
      text-align: left;
      //border: 1px solid red;
    }
  }
  .row2{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2vw;
    font-size: 3.611vw;
    font-weight: 700;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/pages/firstDepositDetail/index.vue